import { __awaiter, __generator } from "tslib";
import { useEffect, useState } from "react";
export var useFullScreenMode = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.initMode, initMode = _c === void 0 ? false : _c;
    var _d = useState(initMode), isFullScreen = _d[0], setIsFullScreen = _d[1];
    var handleKeyDown = function () {
        if (document.fullscreenElement === null) {
            setIsFullScreen(false);
        }
    };
    var changeFullScreen = function (show) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!show) return [3 /*break*/, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    setIsFullScreen(true);
                    return [4 /*yield*/, document.documentElement.requestFullscreen()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    /* eslint-disable no-console */
                    console.error("error", error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
                case 5:
                    if (!!show) return [3 /*break*/, 9];
                    _a.label = 6;
                case 6:
                    _a.trys.push([6, 8, , 9]);
                    setIsFullScreen(false);
                    return [4 /*yield*/, document.exitFullscreen()];
                case 7:
                    _a.sent();
                    return [3 /*break*/, 9];
                case 8:
                    error_2 = _a.sent();
                    /* eslint-disable no-console */
                    console.error("error", error_2);
                    return [3 /*break*/, 9];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        document.addEventListener("fullscreenchange", handleKeyDown);
        return function () {
            document.removeEventListener("fullscreenchange", handleKeyDown);
        };
    }, [isFullScreen]);
    return { isFullScreen: isFullScreen, changeFullScreen: changeFullScreen };
};
